import { render } from "./EleringFormItem.vue?vue&type=template&id=c2bbb026&scoped=true"
import script from "./EleringFormItem.vue?vue&type=script&lang=js"
export * from "./EleringFormItem.vue?vue&type=script&lang=js"

import "./EleringFormItem.vue?vue&type=style&index=0&id=c2bbb026&lang=scss&scoped=true"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2bbb026"]])

export default __exports__